<script>
import ColorPicker from "./ColorPicker.vue";

export default {
  name: "ColorSchemeBox",
  components: {
    ColorPicker,
  },
  props: {
    styling: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      default: "Color Scheme",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    colorScheme: {
      type: Array,
      default: () => ['header', 'body', 'footer']
    }
  },
  data() {
    return {};
  },
  methods: {
    onColorChange(color, value) {
      this.styling[color] = value;
    }
  }
};
</script>

<template>
    <div class="d-flex flex-column">
        <label class="label">{{ label }}</label>
        <div class="color-scheme-grid" v-for="color in colorScheme" :key="color">
            <ColorPicker :modelValue="styling[color]" @change="onColorChange(color, $event)" :disabled="disabled" />
        </div>
    </div>
</template>

<style scoped lang="scss">
.label {
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 4px;
}

.color-scheme-grid {
    display: flex;
    flex-direction: column;
    margin-bottom: 5px;

    &:last-child {
        margin-bottom: 0px;
    }
}
</style>